import './ProgressBar.css';

interface ProgressBarProps {
  value: number;
  max: number;
  /** Accessible label describing what the bar measures (e.g. "3 of 10 documents received"). */
  label: string;
}

/** Compact inline progress bar — 10-design-system.md §4.6/§4.12 pattern already used on the
 * Admissions student detail "documents received" stat, promoted here into a shared primitive so
 * Student Affairs (list + detail) can reuse it without duplicating the CSS. */
export function ProgressBar({ value, max, label }: ProgressBarProps) {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      className="fa-progressbar"
    >
      <div className="fa-progressbar__bar" style={{ width: `${pct}%` }} />
    </div>
  );
}
